import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import Box from "components/common/Box";
import {
  HOLDINGS_HUB_PATH,
  MARKET_PULSE_HUB_PATH,
  UNIFIED_DASHBOARD_PATH,
} from "components/allInOneDashboard/constants/productRouteMap";

const ROUTE_ORDER = {
  [UNIFIED_DASHBOARD_PATH]: 0,
  [HOLDINGS_HUB_PATH]: 1,
  [MARKET_PULSE_HUB_PATH]: 2,
  "/customer/profile": 3,
  "/customer/blogs": 4,
};

/**
 * Slide animation wrapper. Key must track pathname synchronously.
 * Updating key via useEffect + setState remounts children twice
 * (once with the old key, once after animKey updates) and double-fires
 * dashboard data fetches when navigating blogs → dashboard.
 */
const AllInOnePageTransition = ({ children }) => {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const directionRef = useRef("forward");

  const currentPath = location.pathname;
  const previousPath = prevPathRef.current;

  if (previousPath !== currentPath) {
    const previousOrder = ROUTE_ORDER[previousPath] ?? 0;
    const currentOrder = ROUTE_ORDER[currentPath] ?? 0;
    directionRef.current =
      currentOrder >= previousOrder ? "forward" : "backward";
    prevPathRef.current = currentPath;
  }

  const animationName =
    directionRef.current === "forward"
      ? "aioSlideInForward"
      : "aioSlideInBackward";

  return (
    <Box
      key={currentPath}
      sx={{
        animation: `${animationName} 0.35s cubic-bezier(0.4, 0, 0.2, 1)`,
        "@keyframes aioSlideInForward": {
          from: { opacity: 0, transform: "translateX(20px)" },
          to: { opacity: 1, transform: "translateX(0)" },
        },
        "@keyframes aioSlideInBackward": {
          from: { opacity: 0, transform: "translateX(-20px)" },
          to: { opacity: 1, transform: "translateX(0)" },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default AllInOnePageTransition;
